import axiosInstance from "@/api/axios-instance";
import {
  NotificationStats,
  NotificationDetail,
} from "@/pages/notifications/types/notification";

export async function getNotifications({
  page,
  search,
  status,
  startDate,
  endDate,
  tags,
  template,
  type,
}: {
  page?: number;
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  tags?: boolean;
  template?: string;
  type?: string;
}) {
  const params: Record<string, string> = { page: (page || 0).toString() };

  if (search) params.search = search;
  if (status && status !== "ALL") params.status = status;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (typeof tags === "boolean") params.tags = String(tags);
  if (template && template !== "ALL") params.template = template;
  if (type && type !== "ALL") params.type = type;

  const response = await axiosInstance.get(`/notifications`, { params });

  const {
    notifications,
    lastPage,
    page: currentPage,
    totalCount,
  } = response.data;
  return {
    notifications,
    currentPage,
    lastPage,
    totalCount,
  };
}

export const getNotificationStats = async (): Promise<NotificationStats> => {
  try {
    const response = await axiosInstance.get("/notifications/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching notification stats:", error);
    throw error;
  }
};

export const getNotificationById = async (
  id: string
): Promise<NotificationDetail> => {
  try {
    const response = await axiosInstance.get(`/notifications/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching notification with ID ${id}:`, error);
    throw error;
  }
};

export const sendNotificationAnyway = async (
  sessionId: string,
  notificationId: string
) => {
  try {
    const response = await axiosInstance.post(`/notifications/send-anyway`, {
      sessionId,
      notificationId,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error sending notification for session ${sessionId}:`,
      error
    );
    throw error;
  }
};

export const bulkUpdateNotificationStatus = async (
  ids: string[],
  status: string
) => {
  try {
    const response = await axiosInstance.post(
      `/notifications/bulk-update-status`,
      {
        ids,
        status,
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error bulk updating notification statuses:`, error);
    throw error;
  }
};

export const exportNotificationsCsv = async ({
  page,
  search,
  status,
  startDate,
  endDate,
  template,
  type,
}: {
  page?: number;
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  template?: string;
  type?: string;
}) => {
  const params: Record<string, string> = { page: (page || 0).toString() };

  if (search) params.search = search;
  if (status && status !== "ALL") params.status = status;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (template && template !== "ALL") params.template = template;
  if (type && type !== "ALL") params.type = type;
  const response = await axiosInstance.get(`/notifications/export`, {
    params,
    responseType: "blob",
  });

  return response.data;
};

export const getNotificationTemplates = async (): Promise<{
  templates: string[];
}> => {
  const response = await axiosInstance.get(`/notifications/templates`);
  return response.data;
};

export const updateNotificationTags = async (
  notificationId: string,
  tags: string[]
) => {
  try {
    const response = await axiosInstance.post(`/notifications/tags`, {
      notificationId,
      tags,
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating notification tags ${notificationId}:`, error);
    throw error;
  }
};
